export const labelDescriptionVariants = {
  NOTREADY: 0,
  INSYSTEM: 1,
  INPROCESS: 2,
  CATEGORIES: 3,
};